import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

export const useRecentProperties = (type: string) => {
  const axios = useAxios(type);
  const { t } = useTranslation();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const panel = Number(queryParams.get("panel")) || 0;
  const page = Number(queryParams.get("page")) || 1;
  const limit = Number(queryParams.get("limit")) || 10; // Default to 10 if not provided
  const urlKey = `${t(
    "recently-property-list-api"
  )}?page=${page}&limit=${limit}`;
  const { data, refetch, isLoading, isError, isPlaceholderData } = useQuery({
    queryKey: [`Recent-Properties`, page, limit],
    queryFn: async () => {
      const res = await axios.get(urlKey);
      return res.data;
    },
    placeholderData: (previousData) => previousData,
    enabled: panel === 0 && window.innerWidth >= 768
  });

  return { data: data?.data, refetch, isLoading, isError, isPlaceholderData };
};
